module.exports = "img/flags/GF.f9cd69e.png";